import React from 'react';

import "./GoToPremiumModal.scss";

import { ReactComponent as BigCrown } from "static/icons/big-crown.svg";
import UniversalButton from "../../uiComponents/UniversalButton";

const GoToPremiumModal = ({text}) => {

  const onActionClick = () => {
    window.open('https://bim-search.com/pricing-bimsearch');
  }

  return (
    <div className="go-premium">
      <div className="go-premium__img"><BigCrown /></div>
      <div className="go-premium__header">Go Premium</div>
      <div className="go-premium__text" dangerouslySetInnerHTML={{__html: text}}></div>
      <div className="go-premium__button">
        <UniversalButton
          label="Upgrade"
          size="lg"
          labelColor="white"
          labelHoverColor="white"
          backgroundColor="orange"
          backgroundHoverColor="orange-light"
          isFullWidth
          onClick={onActionClick}
        />
      </div>
    </div>
  );
};

export default GoToPremiumModal;